import React, { useState, useEffect } from "react";

// Icons
import { MdDownloadForOffline } from "react-icons/md";

// Route
import { Link, useParams } from "react-router-dom";

// uuidv4
import { v4 as uuidv4 } from 'uuid';

// Client
import { client, urlFor } from '../client';

// Components
import MasonryLayout from './MasonryLayout';
import Spinner from './Spinner';

// Query
import { pinDetailQuery, pinDetailMorePinQuery } from '../utils/data';


const PinDetail = ({ user }) => {

	const [pins, setPins] = useState(null);
	const [pinDetail, setPinDetail] = useState(null);
	const [comment, setComment] = useState('');
	const [addingComment, setAddingComment] = useState(false);

	// Id...
	const { pinId } = useParams();

	const fetchPinDetails = () => {
		let query = pinDetailQuery(pinId);

		if (query) {
			client.fetch(query)
			.then((data) => {
				setPinDetail(data[0]);

				if (data[0]) {
					query = pinDetailMorePinQuery(data[0]);

					client.fetch(query)
					.then((res) => {
						setPins(res);
					});
				}
			});
		}
	};

	const checkForEnter = (e) => {
		if (e.key === 'Enter') {
			addComment();
		}
	}

	const addComment = () => {
		if (comment) {
			setAddingComment(true);

			client.patch(pinId)
			.setIfMissing({
				comments: []
			})
			.insert('after', 'comments[-1]', [{
				comment,
				_key: uuidv4(),
				postedBy: {
					_type: 'postedBy',
					_ref: user._id
				}
			}])
			.commit()
			.then((data) => {
				fetchPinDetails();
				setComment('');
				setAddingComment(false);
			});
		}
	};

	useEffect(() => {
		fetchPinDetails();
	}, [pinId]);

	if (!pinDetail) {
		return (<Spinner message={"Loading pin..."} />)
	}

    return (
		<>
			<div className="flex xl-flex-row flex-col m-auto bg-white dark:bg-slate-800" style={{ maxWidth: '1500px', borderRadius: '32px' }}>
				<div className="flex justify-center items-center md:items-start flex-initial">
					<img
						src={pinDetail?.image && urlFor(pinDetail.image).url()}
						className="rounded-t-3xl rounded-b-lg"
						alt="user-post"
					/>
				</div>
				<div className="w-full p-5 flex-1 xl:min-w-620">
					<div className="flex items-center justify-between">
						<div className="flex gap-2 items-center">
							<a
								href={`${pinDetail?.image?.asset?.url}?dl=`}
								download
								onClick={(e) => e.stopPropagation()}
								className="bg-white dark:text-white dark:bg-slate-800 w-9 h-9 rounded-full flex items-center justify-center text-dark text-xl opacity-75 hover:opacity-100 hover:shadow-md outline-none">

								<MdDownloadForOffline />
							</a>
						</div>
						<a
							href={pinDetail.destination}
							target="_black"
							className="dark:text-white"
							rel="noreferrer">
							
							{ pinDetail.destination }
						</a>
					</div>
					<div>
						<h1 className="text-4xl font-bold break-words mt-3 dark:text-white">
							{ pinDetail.title }
						</h1>
						<p className="mt-3 dark:text-white">
							{ pinDetail.about }
						</p>
					</div>
					<Link to={`/user-profile/${pinDetail?.postedBy._id}`} className="flex gap-2 mt-5 items-center bg-white dark:bg-slate-800 rounded-lg ">
						<img src={pinDetail?.postedBy.image} className="w-10 h-10 rounded-full" alt="user-profile" />
						<p className="font-bold dark:text-white">{pinDetail?.postedBy.userName}</p>
					</Link>
					<h2 className="mt-5 text-2xl dark:text-white">
						Comments
					</h2>
					<div className="max-h-370 overflow-y-auto">
						{
							pinDetail?.comments?.map((comment, i) => (
								<div key={i} className="flex gap-2 mt-5 items-center bg-white dark:bg-slate-800 rounded-lg">
									<img
										src={comment.postedBy.image}
										alt="user-profile"
										className="w-10 h-10 rounded-full cursor-pointer"
									/>
									<div className="flex flex-col">
										<p className="font-bold dark:text-white">
											{ comment.postedBy.userName }
										</p>
										<p className="dark:text-white">
											{ comment.comment }
										</p>
									</div>
								</div>
							))
						}
					</div>
					<div className="flex flex-wrap mt-6 gap-3">
						<Link to={`/user-profile/${pinDetail?.postedBy._id}`}>
							<img src={pinDetail?.postedBy.image} className="w-8 h-8 rounded-full cursor-pointer" alt="user-profile" />
						</Link>
						<input
							className="flex-1 border-gray-100 outline-none border-2 p-2 rounded-2xl focus:border-gray-300 dark:text-white"
							type="text"
							placeholder="Add a comment"
							value={comment}
							onKeyDown={checkForEnter}
							onChange={(e) => setComment(e.target.value)}
						/>
						<button type="button" className="bg-red-500 text-white rounded-full px-6 py-2 font-semibold text-base outline-none" onClick={addComment} disabled={addingComment}>
							{
								addingComment ? `Posting the comment...` : `Post`
							}
						</button>
					</div>
				</div>
			</div>
			{
				pins?.length > 0 ? (
					<>
						<h2 className="text-center font-bold text-2xl mt-8 mb-4 dark:text-white">
							More Like This
						</h2>
						<MasonryLayout pins={pins} />
					</>
				) : (
					<Spinner 
						message={"Loading more pins..."}
					/>
				)
			}
		</>
	);
};

export default PinDetail;
